import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-forward-icon',
  templateUrl: './communication-forward.component.html'
})
export class CommunicationForwardComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
